export default "__VITE_ASSET__DuYQZhPP__";